import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import template from '../helpers/template';
import { shipping } from '../helpers/model';
import Header from './partials/Header';
import ParcelLayout from './partials/ParcelLayout';
import NonParcelLayout from './partials/NonParcelLayout';
import Footer from './partials/Footer';
import Error from './partials/Error';
import utils from '../helpers/utils';
import './delivery-options.style.scss';

const DeliveryContent = (props) => {
  const [shippingModel, setShippingModel] = useState(null);
  const {
    quantity,
    itemId,
    storeId,
    price,
    onZipCodeChange
  } = props;
  const [zipCode, setZipCode] = useState(props.zipCode); // eslint-disable-line react/destructuring-assignment

  const onChangeOfZipCode = (data) => {
    const updatedModel = shipping(data?.shipping);
    setZipCode(data?.shipping?.zipCode);
    setShippingModel(updatedModel);
  };

  useEffect(() => {
    if (shippingModel && onZipCodeChange) {
      utils.setDETAZip(zipCode);
      utils.setDeliveryZip(zipCode);
      onZipCodeChange({
        shippingServiceModel: shippingModel,
        zipCode
      });
    }
  }, [shippingModel, zipCode]);

  const model = shippingModel || props.shippingModel; // eslint-disable-line react/destructuring-assignment

  const templateToRender = template.isTemplateToRender({
    model
  });

  return (
    <>
      <div className="delivery-options-content">
        {templateToRender
        && (
          <div className="delivery-options-inner">
            <div className="delivery-options-header">
              <Header
                itemId={itemId}
                zipCode={zipCode}
                price={price}
                onZipCodeChange={onChangeOfZipCode}
                quantity={parseInt(quantity, 10)}
              />
            </div>
            <div className="delivery-options-templates">
              {model?.group?.toLowerCase() === 'parcel'
              && (
                <ParcelLayout
                  shipModes={model.shipModes}
                  arrivalDate={model.arrivalDate}
                  dynamicETA={model.dynamicETA}
                />
              )}
              {model?.group?.toLowerCase() !== 'parcel'
              && (
                <NonParcelLayout
                  shipModes={model.shipModes}
                  arrivalDate={model.arrivalDate}
                  dynamicETA={model.dynamicETA}
                />
              )}
            </div>
            <div>
              <Footer />
            </div>
          </div>
        )}
        {!templateToRender
        && (
          <Error />
        )}
      </div>
    </>
  );
};

DeliveryContent.propTypes = {
  quantity: PropTypes.number.isRequired,
  onZipCodeChange: PropTypes.func,
  itemId: PropTypes.string.isRequired,
  storeId: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  shippingModel: PropTypes.shape({})
};

DeliveryContent.defaultProps = {
  onZipCodeChange: () => {},
  shippingModel: null
};

export default DeliveryContent;